<script>
import { fandomBasicMixin } from 'src/modules/fandom_mixins_module.js';
import { GoogleMapsModule } from 'src/modules/google_maps_module.js';
import { interactionMixin } from 'src/modules/interactions_module.js';
import ModalCarouselPin from "modal-carousel-pin";
import StripeHeader from "stripe-header";
import { merge, get } from 'lodash';
import STYLE_OPTIONS  from '../../modules/gmaps_style_module.js'; 
const DEFAULT_LATITUDE = 45.56397;
const DEFAULT_LONGITUDE = 12.428058;
const DEFAULT_ZOOM = 15;

export default {
  mixins: [fandomBasicMixin, interactionMixin],
  components: {
    ModalCarouselPin,
    StripeHeader
  },
  data() {
    return {
      map: null,
      markers: [],
      openedMarkerIndex: null,
    };
  },
  mounted() {
    GoogleMapsModule.init(this.googleMapsCallback);
  },
  computed: {
    mapSettings() {
      let settings = {
        center: {
          lat: parseFloat(this.content.latitude) || DEFAULT_LATITUDE,
          lng: parseFloat(this.content.longitude) || DEFAULT_LONGITUDE
        },
        zoom: this.content.zoom || DEFAULT_ZOOM,
        disableDefaultUI: true,
        styles: STYLE_OPTIONS,
      };
      if (!!this.content.additional_settings) {
        settings = merge(settings, this.content.additional_settings);
      }
      return settings;
    },
  },
  methods: {
    updateInteraction(marker) {
      this.updatePinInteraction(this.containerContent, marker, marker.interaction);
    },
    initMarkers() {
      if (!!this.content.markers && this.content.markers.length > 0) {
        this.content.markers.forEach((mrk, index) => {
          const markerOptions = {
            position: { lat: parseFloat(mrk.latitude), lng: parseFloat(mrk.longitude) },
            title: mrk.title,
            map: this.map
          };

          const markerIconUrl = mrk.marker_icon || this.content.marker_icon;
          if (!!markerIconUrl) {
            markerOptions.icon = markerIconUrl;
          } else {
            // label must be inserted only if there is no custom pin image
            markerOptions.label = {text: String.fromCharCode(65 + index), color: 'white'}
          }
          let marker = new google.maps.Marker(markerOptions);
          marker.addListener('click', () => {
            const pinUrl = get(mrk, ["url", "url"], false);
            if (pinUrl) {
              if (pinUrl !== "$empty") {
                if (mrk.url.new_tab) {
                  window.open(mrk.url.url);
                } else {
                  window.location.href = mrk.url.url;
                }
              }
            } else {
              this.updateInteraction(mrk);
              Vue.set(this, 'openedMarkerIndex', index);
            }
          });
          this.markers.push(marker);
        });
      }
    },
    googleMapsCallback() {
      console.log("Maps loaded correctly");
      const mapNode = this.$refs[`google-map-${this.contentId}`];
      const settings = this.mapSettings;
      Vue.set(this, 'map', GoogleMapsModule.loadMap(mapNode, settings));
      Vue.nextTick(() => {
        this.initMarkers();
      })
    }
  },
};
</script>

<template>
  <div 
    v-easyadmin="easyadminId" 
    v-if="isContentVisibleToUser()"
    :class="contentType"
    stripe-google-map-component
  > 
    <div class="container py-4" v-if="content.title || content.description">
      <stripe-header :content="content"></stripe-header>
    </div>
    <div :ref="`google-map-${contentId}`" class="h-100vh-header"></div>
    <transition 
      enter-active-class="animated slideInUp" 
      leave-active-class="animated slideOutDown" 
    >
      <modal-carousel-pin
        v-if="content.markers && openedMarkerIndex !== null"
        v-on:close-modal="openedMarkerIndex = null"
        v-on:next="updateInteraction"
        :items="content.markers"
        :containerContent="containerContent"
        :activeIndex="openedMarkerIndex"
        opt-item-layout="pin-content"
      ></modal-carousel-pin>
    </transition>
  </div>
</template>

<style lang="scss">
[stripe-google-map-component] {  }
</style>